import React, { Component } from "react";
import { leadID } from "../Services/fetchService";
import { DomField, DomSelect, DomBoolCheckbox, DomTextarea } from "../Services/formDOM";
import { checkInput, returnValue } from "../Services/Validation";
import { GA_Push } from "../Services/GoogleAnalytics";
import { apiURL, Environment } from "../Services/Base";
import Loading from "../Services/Loading/Loading";
import ModalVideo from "react-modal-video";
import "whatwg-fetch";
import "./Body.scss";

export default class Body extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      isBusy: false,
      isLoading: false,
      pageStyle: "form",
      FileName: {
        value: "",
        name: "FileName",
        error: "",
        isRequired: false,
        shouldValidate: false,
        ImagePlaceholder: "אנא צרפו תמונה של המשפחה"
      },
      captchaEnable: !Environment().isLocalhost
    };
    window.sendCallback = this.sendForm;
  }

  componentDidMount() {
    (() => {
      if (window.document.getElementById("GoogleRecap")) return;

      var script = document.createElement("script");
      script.type = "text/javascript";
      script.id = "GoogleRecap";
      script.async = 1;
      script.defer = 1;
      script.src = "https://www.google.com/recaptcha/api.js";

      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  }

  addState = (stateName, isRequired, shouldValidate) => {
    this.setState({
      [stateName]: {
        name: stateName,
        value: "",
        isRequired: !isRequired ? false : true,
        shouldValidate: !shouldValidate ? false : true
      }
    });
  };

  handleInputChange = event => {
    this.setState({
      [event.target.name]: {
        ...this.state[event.target.name],
        error: "",
        value:
          event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value
      }
    });
  };

  setErrorMessage = (target, errorMsg) => {
    if (!this.state[target.name]) return;

    this.setState({
      [target.name]: {
        ...target,
        error: errorMsg
      }
    });
  };

  openModal = () => this.setState({ isOpen: true });

  setPage = pageStyle =>
    this.setState({
      pageStyle: pageStyle
    });

  checkString = event => {
    let { name, value } = event.target;
    switch (name) {
      default:
        return value;
      // case "PhoneNumber":
      // case "Age":
      //   return this.onlyNumbers(value)
      // case "FullName":
      //   return this.onlyLetters(value)
    }
  };

  onlyLetters = string => string.replace(/[0-9]/i, "");

  onlyNumbers = string => string.replace(/[+\\/!*@#$%^&a-zA-Z\-\u0590-\u05FF]/i, "");

  changeImageLabel = event => {
    var allowdExtensions = ["jpg", "jpeg", "gif", "png"];
    var file = event.target.files[0];
    if (file) {
      if (file.size > 5242880) {
        alert("לא ניתן להעלות קבצים מעל 5mb");
        event.target.value = "";
        return false;
      }

      var isAllowd = false;
      allowdExtensions.forEach(extension => {
        if (file.type.indexOf(extension) > -1) {
          isAllowd = true;
        }
      });

      if (!isAllowd) {
        alert("ניתן לעלות רק קבצי תמונה");
        event.target.value = "";
        return false;
      }

      this.setState({
        FileName: {
          ...this.state.FileName,
          name: file.name,
          value: file,
          error: "",
          label: "",
          ImagePlaceholder: file.name,
          id: "FileName"
        }
      });
    } else {
      return false;
    }
  };

  saveAndValidate = async () => {
    if (this.state.isBusy) return;

    this.setState({
      isLoading: true,
      isBusy: true
    });

    let isError = false,
      j = 0,
      jsonBody = {},
      stateValidate = Object.filter(this.state, s => s.shouldValidate),
      state = Object.filter(this.state, s => s.isRequired),
      fieldstateValidateKeys = Object.keys(stateValidate),
      fieldStateKeys = Object.keys(state);

    for (let s in stateValidate) {
      if (await !checkInput(stateValidate[s], this.setErrorMessage)) isError = true;
      j++;
    }

    for (let k in fieldStateKeys) {
      jsonBody = Object.assign(jsonBody, {
        [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
      });
    }

    if (isError && j == fieldstateValidateKeys.length) {
      this.setState({
        isLoading: false,
        isBusy: false
      });
      return;
    }

    this.setState(
      {
        jsonBody,
        isLoading: true,
        isBusy: true
      },
      () => (this.state.captchaEnable ? window.grecaptcha.execute() : this.sendForm())
    );
  };

  sendForm = async () => {
    let formData = new FormData();
    let formDataEmailPhone = new FormData();
    const { jsonBody } = this.state;

    formData.append("LeadID", leadID.toString());
    formDataEmailPhone.append("LeadID", leadID.toString());
    for (let k = 0; k < Object.keys(jsonBody).length; k++) {
      let _key = Object.keys(jsonBody)[k];
      formData.append(_key, jsonBody[_key]);
      if (_key == "PhoneNumber" || _key == "Email") {
        formDataEmailPhone.append(_key, jsonBody[_key]);
      }
    }

    this.state.captchaEnable ? window.grecaptcha.reset() : null;

    let isExists = await fetch(`${apiURL}IsExists`, {
      method: "POST",
      body: formDataEmailPhone
    }).then(data => data.json());

    if (isExists) {
      this.setState({
        isLoading: false,
        isBusy: false,
        pageStyle: "already"
      });
      return;
    }
    fetch(`${apiURL}Save`, {
      method: "POST",
      body: formData
    })
      .then(data => data.json())
      .then(data => {
        this.setState({
          isLoading: false,
          isBusy: false,
          pageStyle: "done"
        });
        GA_Push("form_sent");
        if (this.state.captchaEnable) {
          window.grecaptcha.reset();
        }
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isBusy: false
        });
      });
  };
  render() {
    return (
      <section className={`section-form ${this.state.pageStyle}`}>
        <div className="padding">
          <div className="container">
            <div className="form">
              <Loading showLoading={this.state.isLoading} />
              <div className="row first">
                <DomTextarea
                  type="text"
                  _settings={{
                    maxLength: 2883
                  }}
                  label="ספרו לנו..."
                  placeholder="ספרו לנו..."
                  name="PlainText"
                  id="PlainText"
                  className=""
                  isRequired
                  shouldValidate
                  onChange={this.handleInputChange}
                  onLoad={this.addState}
                  {...this.state}
                />
                {/* <DomTextarea
                  type="text"
                  _settings={{
                    maxLength: 2883
                  }}
                  label="תנו לנו את הטיפ שלכם כיצד הופכים ילדים לאלופים"
                  placeholder="תנו לנו את הטיפ שלכם כיצד הופכים ילדים לאלופים"
                  name="PlainText2"
                  id="PlainText2"
                  className=""
                  isRequired
                  shouldValidate
                  onChange={this.handleInputChange}
                  onLoad={this.addState}
                  {...this.state} /> */}
              </div>
              <div className="row">
                <DomField
                  type="text"
                  max={64}
                  label="שם"
                  placeholder="שם"
                  name="ExtraField1"
                  id="ExtraField1"
                  isRequired
                  shouldValidate
                  onChange={this.handleInputChange}
                  onLoad={this.addState}
                  {...this.state}
                />
                <DomField
                  type="text"
                  max={64}
                  label="שם משפחה"
                  placeholder="שם משפחה"
                  name="ExtraField2"
                  id="ExtraField2"
                  isRequired
                  shouldValidate
                  onChange={this.handleInputChange}
                  onLoad={this.addState}
                  {...this.state}
                />
                <DomField
                  type="email"
                  max={64}
                  label="אימייל"
                  placeholder="אימייל"
                  name="Email"
                  id="Email"
                  isRequired
                  shouldValidate
                  onChange={this.handleInputChange}
                  onLoad={this.addState}
                  {...this.state}
                />
                <DomField
                  type="tel"
                  max={64}
                  label="טלפון"
                  placeholder="טלפון"
                  name="PhoneNumber"
                  id="PhoneNumber"
                  isRequired
                  shouldValidate
                  onChange={this.handleInputChange}
                  onLoad={this.addState}
                  {...this.state}
                />
                <div
                  className="button2"
                  onClick={() => {
                    this.saveAndValidate();
                  }}
                >
                  <div
                    className="g-recaptcha"
                    data-callback="sendCallback"
                    data-size="invisible"
                    data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"
                  ></div>
                </div>
                {/* <div className="moreinfo">
                  <DomField
                  type="tel"
                  max={64}
                  label="גיל"
                  placeholder="גיל"
                  name="Age"
                  id="Age"
                  isRequired
                  shouldValidate
                  onChange={this.handleInputChange}
                  onLoad={this.addState}
                  {...this.state} /> */}
                {/* <DomSelect
                  placeholder="מין"
                  name="Gender"
                  id="Gender"
                  isRequired
                shouldValidate
                  onChange={this.handleInputChange}
                  onLoad={this.addState}
                  {...this.state} /> */}
                {/* </div> */}
                <div className="moreinfo">
                  {/* <DomField
                    type="tel"
                    max={64}
                    label="גיל"
                    placeholder="גיל"
                    name="Age"
                    id="Age"
                    isRequired
                    shouldValidate
                    onChange={this.handleInputChange}
                    onLoad={this.addState}
                    {...this.state} /> */}
                </div>
              </div>
              <div className="row terms">
                <DomBoolCheckbox
                  label={`קראתי, הבנתי, ומסכים <a href=${`https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html`} target="_blank">לתנאי השימוש</a>, 
                <a href=${`https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html`} target="_blank">למדיניות הפרטיות</a>
                 ו<a href=${`https://z.ynet.co.il/mShort/generics/Leads/TOS/${leadID}/`} target="_blank">לתקנון הפעילות</a>, וכן נותן הסכמתי למשלוח דברי פרסום לפי פרטיי לעיל`}
                  type="checkbox"
                  name="TOS"
                  id="TOS"
                  shouldValidate
                  onChange={this.handleInputChange}
                  onLoad={this.addState}
                  {...this.state}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

/*
 <div className="row">
                <div className="button" onClick={() => {
                  this.saveAndValidate()
                }}>
                  <div className="button-text">שלח/י</div>
                  <div className="g-recaptcha"
                    data-callback="sendCallback"
                    data-size="invisible"
                    data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"></div>
                </div>
              </div>
*/



// WEBPACK FOOTER //
// ./src/Components/Body/Body.jsx